import Icon from '@xo-union/tk-component-icons';
import { Subhead } from '@xo-union/tk-ui-typography';
import React, { useContext, useRef, useState } from 'react';
import { Link, Route, Switch } from 'react-router-dom';

import { useRegistrySummaryQuery, useWeddingWebsiteQuery } from '../generated/graphql';
import { purchaseDomainRenewalRoute, purchaseDomainRoute, websiteSettingsRoute } from '../helpers/routes';
import { TrackingContext } from '../TrackingContext';
import CustomDomainInformation from './CustomDomainInformation';
import PurchaseDomainModal from './PurchaseDomainModal';
import PurchaseDomainRenewalModal from './PurchaseDomainModal/Renewal';
import styles from './rightContainer.scss';
import { SettingsRail } from './SettingsRail';
import { ThemeSettings } from './ThemeSettings';
import { Snackbar, SnackbarMessage } from './Snackbar';
import RegistryCard from './InfoHeader/guidanceCards/RegistryCard';
import GuidanceModule from './InfoHeader/GuidanceModule';
import registryInfo from '../helpers/registryInfo';
import { Divider } from './SettingsRail/Divider';
import classNames from 'classnames';

interface RightContainerDividerProps {
  includeMargin?: boolean;
}

export const RightContainerDivider = ({ includeMargin = true }: RightContainerDividerProps) => (
  <Divider
    additionalStyles={includeMargin ? styles.rightContainer__divider : styles.rightContainer__divider__noMargin}
  />
);

const RightContainer: React.FC = () => {
  const { data } = useWeddingWebsiteQuery();
  const [open, setOpen] = useState(false);
  const body = useRef<HTMLDivElement>(null);
  const [toastMessage, setToastMessage] = useState({} as SnackbarMessage);

  const { track } = useContext(TrackingContext);
  const managePrivacyClickEvent = () => {
    track('WWS Dashboard Interaction', {
      action: 'update',
      actionName: 'Privacy Settings',
    });
  };

  const purchaseDomain = data?.weddingWebsite.purchaseDomain || undefined;
  const { name: domainName } = purchaseDomain || {};

  const { data: registryData } = useRegistrySummaryQuery();
  const { hasAnyRegistry } = registryInfo(registryData?.registrySummary);

  const onOpen = () => {
    setOpen(prev => {
      if (body.current) {
        if (body.current?.style.maxHeight) {
          body.current.style.maxHeight = '';
        } else {
          body.current.style.maxHeight = '100%';
        }
      }
      return !prev;
    });
  };
  return (
    <>
      <Snackbar clearToastMessage={setToastMessage} toastMessage={toastMessage} />
      <SettingsRail />
      <Switch>
        <Route exact path={purchaseDomainRoute}>
          <PurchaseDomainModal setDomainPaymentToastMessage={setToastMessage} />
        </Route>
        <Route exact path={purchaseDomainRenewalRoute}>
          <PurchaseDomainRenewalModal domain={purchaseDomain} />
        </Route>
      </Switch>
      <div className={styles.rightContainer}>
        <div className={styles.accordion}>
          <button className={styles.accordion__Header} onClick={onOpen}>
            <Icon
              name="caret_right"
              className={classNames(styles.accordion__CaretIcon, { [styles.accordion__CaretIcon__open]: open })}
              size="md"
            />
            <Subhead as="h2">Settings</Subhead>
          </button>
        </div>
        <div ref={body} className={styles.accordion__Body}>
          <div className={styles.accordion__Content}>
            <div className={styles.rightContainer__privacySettings__wrapper}>
              <Subhead as="h2">Privacy settings</Subhead>
              <Link onClick={managePrivacyClickEvent} to={websiteSettingsRoute} data-testid="privacy_settings_manage">
                Manage
              </Link>
            </div>
            <RightContainerDivider />

            <ThemeSettings>
              <GuidanceModule layout="column">{!hasAnyRegistry && <RegistryCard />}</GuidanceModule>
            </ThemeSettings>

            {domainName && (
              <>
                <RightContainerDivider />
                <CustomDomainInformation domain={purchaseDomain} />
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default RightContainer;
